import { ISalesFunnelStage } from '@user/store/salesFunnel/typings'
import { LEAD_STATUSES } from '../LeadCard/typings'

export const getLeadStatus = (
  stages: ISalesFunnelStage[],
  salesFunnelStageId: number,
): LEAD_STATUSES => {
  const currentStage = stages
    .filter((stage) => stage.id == salesFunnelStageId)
    .shift()

  if (!currentStage) {
    return LEAD_STATUSES.Open
  } else {
    const { name } = currentStage

    switch (name) {
      case 'Qualify':
        return LEAD_STATUSES.Qualify
      case 'Disqualified':
        return LEAD_STATUSES.Disqualified
      default:
        return LEAD_STATUSES.Open
    }
  }
}
